import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import Config from "../models/Config";
import Species from "./Species";

export default function SpeciesMenu(props) {
  const { showSpecies, setShowSpecies } = props;
  const speciesKeys = Object.keys(Config);

  return (
    <div className="mx-auto max-w-6xl text-center">
      <div className="flex flex-col items-center gap-2">
        <h2 className="font-display text-2xl sm:text-3xl font-semibold text-ink">
          Select a species platform
        </h2>
      </div>

      {showSpecies ? (
        <div className="mt-7 animate-fade-in">
          <div className="flex flex-wrap justify-center gap-4">
            {speciesKeys.map((item, i) => (
              <Species key={item} type={Config[item]} index={i} />
            ))}
          </div>
          <div className="mt-7">
            <button
              onClick={() => setShowSpecies(false)}
              className="inline-flex items-center gap-1.5 rounded-full border border-moss-200 bg-white/70 px-4 py-2 text-sm font-medium text-moss-800 shadow-sm transition-colors hover:bg-white hover:text-moss-900"
            >
              <ChevronUpIcon className="h-4 w-4" />
              Hide species
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-6">
          <button
            onClick={() => setShowSpecies(true)}
            className="inline-flex items-center gap-1.5 rounded-full bg-moss-900 px-5 py-2.5 text-sm font-semibold text-paper shadow-soft transition-all hover:-translate-y-0.5 hover:bg-moss-800"
          >
            <ChevronDownIcon className="h-4 w-4" />
            Show all species
          </button>
        </div>
      )}
    </div>
  );
}
